import React from 'react';

export const CSSNeuralPoster: React.FC = () => {
  return (
    <div
      className="fixed inset-0 pointer-events-none z-0 overflow-hidden select-none bg-[#070709]"
      aria-hidden="true"
    >
      {/* Primary Ambient Sunset Radial Glow */}
      <div
        className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] sm:w-[950px] h-[450px] sm:h-[600px] rounded-full opacity-35 blur-[100px] sm:blur-[140px] pointer-events-none animate-pulse-subtle"
        style={{
          background: 'radial-gradient(ellipse at center, rgba(255, 175, 1, 0.45) 0%, rgba(250, 80, 15, 0.25) 45%, rgba(196, 0, 29, 0.1) 75%, transparent 100%)',
        }}
      />

      {/* Secondary Depth Amber Core Glow */}
      <div
        className="absolute top-[42%] left-[48%] -translate-x-1/2 -translate-y-1/2 w-[400px] sm:w-[550px] h-[300px] sm:h-[400px] rounded-full opacity-25 blur-[80px] pointer-events-none"
        style={{
          background: 'radial-gradient(circle, rgba(212, 175, 55, 0.5) 0%, rgba(245, 80, 54, 0.2) 60%, transparent 100%)',
        }}
      />

      {/* Concentric Geometric Orbital Manifold Rings (SVG) */}
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[580px] sm:w-[760px] h-[580px] sm:h-[760px] opacity-40">
        <svg viewBox="0 0 800 800" className="w-full h-full animate-[spin_120s_linear_infinite]">
          {/* Inner ring */}
          <circle
            cx="400"
            cy="400"
            r="160"
            fill="none"
            stroke="rgba(255, 175, 1, 0.25)"
            strokeWidth="1"
            strokeDasharray="4 8"
          />
          {/* Middle torus trajectory */}
          <ellipse
            cx="400"
            cy="400"
            rx="260"
            ry="190"
            fill="none"
            stroke="rgba(212, 175, 55, 0.3)"
            strokeWidth="1.2"
            strokeDasharray="6 12"
            transform="rotate(-25 400 400)"
          />
          <ellipse
            cx="400"
            cy="400"
            rx="260"
            ry="190"
            fill="none"
            stroke="rgba(250, 80, 15, 0.25)"
            strokeWidth="1.2"
            strokeDasharray="8 16"
            transform="rotate(35 400 400)"
          />
          {/* Outer field ring */}
          <circle
            cx="400"
            cy="400"
            r="340"
            fill="none"
            stroke="rgba(255, 255, 255, 0.08)"
            strokeWidth="1"
            strokeDasharray="2 10"
          />
          {/* Orbital nodes */}
          <circle cx="400" cy="240" r="3.5" fill="#ffaf01" />
          <circle cx="580" cy="400" r="3" fill="#fa500f" />
          <circle cx="280" cy="530" r="3" fill="#d4af37" />
          <circle cx="400" cy="560" r="2.5" fill="#ff8204" />
        </svg>
      </div>

      {/* Subtle Bottom Ground Horizon Glow */}
      <div
        className="absolute bottom-0 left-0 right-0 h-48 opacity-20 pointer-events-none"
        style={{
          background: 'linear-gradient(to top, rgba(255, 175, 1, 0.15) 0%, transparent 100%)',
        }}
      />
    </div>
  );
};
